import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-gdo-connected-garage-introduction-video-dialog',
    templateUrl: './gdo-connected-garage-introduction-video-dialog.component.html',
    styleUrls: ['./gdo-connected-garage-introduction-video-dialog.component.scss'],
    standalone: false
})
export class GdoConnectedGarageIntroductionVideoDialogComponent implements OnInit {

  isAcura: boolean = false;
  public isWebView: boolean = true;
  constructor(private dialogRef: MatDialogRef<GdoConnectedGarageIntroductionVideoDialogComponent>,
    private appService: AppService

  ) { }

  ngOnInit(): void {
    this.setIsAcuraLocally();
    this.isWebView = this.appService.getWebviewCurrentStatus();
  }
  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }
  onClickClose() {
    this.dialogRef.close();
  }
  toggleVideo() { }
}
